/** @format */

import React, { useEffect } from 'react';
import { Link, Redirect } from 'react-router-dom';
import { useTranslation } from 'react-i18next/hooks';
import { useStoreState, useStoreActions } from 'easy-peasy';

import Background from '../Background';
import TravelSelect from './TravelSelect';
import TopSection from '../TopSection/TopSection';

function TravelsSelect({
    match: {
        params: { id },
    },
}) {
    const [t] = useTranslation('translation');
    const service = useStoreActions((actions) => actions.travelsSelect);
    const data = useStoreState((state) => state.travelsSelect);
    const travelSearchData = useStoreState((state) => state.travelSearch);
    const bookingData = useStoreState((state) => state.cart);
    const bookingService = useStoreActions((actions) => actions.cart);
    const travelReady = (travel) => travel !== null && travel !== 'loading';

    useEffect(() => {
        service.reset();
        bookingService.reset();
        bookingService.setTitle(travelSearchData);
        bookingService.setItems(travelSearchData);
        service.setStops(travelSearchData);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [bookingService]);

    useEffect(() => {
        if (travelSearchData.departureDate != null) {
            service.fetchTravelsOut({
                travelSearchData,
                travelsSelectData: data,
            });
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [service, travelSearchData.departureDate]);

    if (travelSearchData.fromStop === null) {
        return <Redirect to={'/'} />;
    }

    return (
        <div id={id}>
            <section>
                <Background />
                <TopSection />
            </section>
            <section>
                <div className='linkandheading'>
                    <Link to='/'></Link>
                    <h1>{t('selectYourTrip')}</h1>
                    <Link to='/'></Link>
                </div>
                <div>
                    <TravelSelect
                        fromStopName={data.fromStopName}
                        toStopName={data.toStopName}
                        travels={data.travelsOut}
                        searchDate={travelSearchData.searchDate}
                        loading={!travelReady(data.travelsOut)}
                        lastClickedTravel={data.lastClickedTravel}
                    />
                    <div className='verticalSpace8' />
                    {new Date(travelSearchData.departureDate) >
                    new Date(2026, 5, 22) ? (
                        <>
                            <div className={'verticalSpace4'} />
                            <div className='info-message'>
                                {t('noShowInfo')} {t('noShowInfoReadMore')}{' '}
                                <a
                                    href={`${process.env.PUBLIC_URL}/Terms`}
                                    target='_new'
                                    title={t('opensInNewTab')}
                                >
                                    {t('noShowInfoTermsLink')}
                                </a>
                                .
                            </div>
                            <div className={'verticalSpace12'} />
                        </>
                    ) : (
                        <div className={'verticalSpace18'} />
                    )}
                    <Link
                        to={'/contact/' + id}
                        className={
                            bookingData.tripInValidCode !== ''
                                ? 'btn_default disabled'
                                : 'btn_default'
                        }
                    >
                        {t('BookTrip')}
                    </Link>
                </div>
            </section>
        </div>
    );
}

export default TravelsSelect;
